import { Avatar, Popover } from 'antd'
import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import config from 'config'

import './styles.less'
import { observer } from 'mobx-react-lite'
import { EasyDrawContext } from '@/store'
import { UserOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import Login from '@/pages/Auth/Login'
import { UnLoginPopoverContent, LoginPopoverContent } from '@/components/UserAvatar/PopoverContent'
import PayModal from '../PayModal'

export type AvatarProps = {
  className?: string
  navigate?: string
}

export const UserAvatar = observer((props: AvatarProps) => {
  const store = useContext(EasyDrawContext)
  const user = store.userStore
  const navigate = useNavigate()
  const [loginVisible, setLoginVisible] = useState(false)
  const[paymentVisible, setPaymentVisible] = useState(false)

  const handleLogout = async () => {
    window.location.href = '/auth/logout'
  }

  const handleSetting = () => {
    navigate('/setting')
  }

  // 未登录用户
  if (!user.isValidUser) {
    return (
      <>
        <Popover 
          arrow={false} 
          content={<UnLoginPopoverContent handleLogin={() => setLoginVisible(true)} />} 
          placement="bottomRight"
        >
          <Avatar
            className={classNames('user-avatar', props.className)}
            style={{ backgroundColor: '#faa665' }}
            icon={<UserOutlined />}
            size="large"
          />
        </Popover>
        <Login
          visible={loginVisible}
          onClose={() => setLoginVisible(false)}
        />
      </>
    )
  }

  const handleUpgrade = () => {
    // 处理VIP升级逻辑
    console.log('升级VIP')
    setPaymentVisible(true)
  }

  return (
    <Popover 
      arrow={false}
      content={
        <LoginPopoverContent 
          user={user}
          onSetting={handleSetting}
          onLogout={handleLogout}
          onUpgrade={handleUpgrade}
        />
      }
      placement="bottomRight"
    >
      {(!user.avatar && !user.nickname && !user.userName) ? (
          <>
            <Avatar
              className={classNames('user-avatar', props.className)}
              style={{ backgroundColor: '#faa665' }}
              icon={<UserOutlined />}
              size="large"
            />
          </>
        ) :
        (
          <Avatar
            className={classNames('user-avatar', props.className)}
            src={`${store.userStore.avatar || ''}`}
            size="large"
          >
            {store.userStore.nickname}
          </Avatar>
        )
      }
      <PayModal
        visible={paymentVisible}
        user={user}
        onSuccess={() => {
          setPaymentVisible(false)
          user.queryUserInfo(true)
        }}
        onClose={() => setPaymentVisible(false)}
      />
    </Popover>
  )
})